import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

const isVisiblePackage = (pkg) => !!pkg && !pkg.isHidden;

export const useFilteredPackages = (filters = []) => {
  return useSelector((state) => {
    const packages = Global.selectSellerPackages(state) || [];
    return packages.filter((pkg) => [...filters, isVisiblePackage].every((filter) => filter(pkg, state)));
  });
};
